var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { UserKycStatusSynaps } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import Loader from '@cta-portal/webapp-common/src/components/loader';
import { Upvoty } from '@upvoty/react';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { FeedbackTab, RoutePath, generateRoutePath } from '../../app/router/config';
import InputSelect from '../../components/common/input-select';
import NoKyc from '../../components/common/no-kyc';
import Header from '../../components/feedback/header';
import { UserContext } from '../../context/user';
import { appEnv } from '../../env';
import Layout from '../../layout';
function Feedback() {
    var _a;
    var t = useI18n().t;
    var navigate = useNavigate();
    var user = useContext(UserContext).user;
    var tabParam = useParams().tab;
    var _b = useState(undefined), token = _b[0], setToken = _b[1];
    var _c = useState(false), tabInitialized = _c[0], setTabInitialized = _c[1];
    var _d = useState(tabParam), currentTab = _d[0], setCurrentTab = _d[1];
    var tabs = [
        {
            label: t('feedback.question.label'),
            value: FeedbackTab.QUESTION,
            path: generateRoutePath(RoutePath.FEEDBACK, { tab: FeedbackTab.QUESTION }),
            selected: currentTab === FeedbackTab.QUESTION,
            projectId: appEnv.isLive ? 'f30e807f-e276-430f-b273-6162544d0e19' : 'c3447064-fe3a-4102-81b8-8b77a92d0b6a',
            boardId: appEnv.isLive
                ? 'board-0c3a002d-18c5-4274-8453-f13ba0d617d9'
                : 'board-912792d2-a63c-4e51-8ccc-2cc217cc2596',
            description: t('feedback.question.description'),
        },
        {
            label: t('feedback.representative.label'),
            value: FeedbackTab.REPRESENTATIVE,
            path: generateRoutePath(RoutePath.FEEDBACK, { tab: FeedbackTab.REPRESENTATIVE }),
            selected: currentTab === FeedbackTab.REPRESENTATIVE,
            projectId: appEnv.isLive ? '94a72346-8248-43d1-a12c-b0cb72a53cf3' : 'c3447064-fe3a-4102-81b8-8b77a92d0b6a',
            boardId: appEnv.isLive
                ? 'board-8da6cf9a-59b0-4862-93a2-3808d80ce9b6'
                : 'board-2870100a-204d-43ee-b14f-22cb0a137815',
            description: t('feedback.representative.description'),
        },
        {
            label: t('feedback.portal.label'),
            value: FeedbackTab.PORTAL,
            path: generateRoutePath(RoutePath.FEEDBACK, { tab: FeedbackTab.PORTAL }),
            selected: currentTab === FeedbackTab.PORTAL,
            projectId: appEnv.isLive ? '68df774e-92f1-4741-984c-bd2493c04f05' : '68df774e-92f1-4741-984c-bd2493c04f05',
            description: t('feedback.portal.description'),
            // boardId: 'board-cdfdc147-1f56-46cb-b077-ff88b4ed1047',
        },
    ];
    var tab = tabs.find(function (_a) {
        var selected = _a.selected;
        return selected === true;
    });
    useEffect(function () {
        if (!currentTab) {
            return;
        }
        if (currentTab && !Object.values(FeedbackTab).includes(currentTab)) {
            setCurrentTab(undefined);
            return;
        }
        if (tab && !tabInitialized) {
            setTabInitialized(true);
            navigate(tab.path, {
                replace: true,
            });
            return;
        }
        window.location.href = generateRoutePath(RoutePath.FEEDBACK, { tab: currentTab });
    }, [currentTab]);
    useEffect(function () {
        function getToken() {
            return __awaiter(this, void 0, void 0, function () {
                var result;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!tab || ((_a = user === null || user === void 0 ? void 0 : user.kyc) === null || _a === void 0 ? void 0 : _a.statusSynaps) !== UserKycStatusSynaps.APPROVED)
                                return [2 /*return*/];
                            return [4 /*yield*/, gqlSdk.UserGetUpvotyJwt({ input: { projectId: tab.projectId } })];
                        case 1:
                            result = _b.sent();
                            setToken(result.userGetUpvotyJwt.jwt);
                            return [2 /*return*/];
                    }
                });
            });
        }
        getToken();
    }, [user, tab]);
    useEffect(function () {
        var observer = new MutationObserver(function (mutations) {
            for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
                var mutation = mutations_1[_i];
                if (mutation.type === 'childList') {
                    var iframe = window.document.querySelector('iframe[data-upvoty-portal-id]');
                    if (iframe && tab && tab.boardId) {
                        // Update the board id because the embed.js script is wrongly splitting the '-'
                        var reducedBoardId = tab.boardId.replace('board-', '');
                        var url = new URL(iframe.src);
                        url.searchParams.set('board', reducedBoardId || '');
                        iframe.src = url.toString();
                    }
                }
            }
        });
        var target = window.document.body;
        observer.observe(target, { childList: true, subtree: true });
        return function () {
            observer.disconnect();
        };
    }, [tab]);
    return (_jsxs(_Fragment, { children: [tab && _jsx(Upvoty, { projectId: tab.projectId }), _jsx(Layout, { children: _jsxs(_Fragment, { children: [_jsx(Header, {}), ((_a = user === null || user === void 0 ? void 0 : user.kyc) === null || _a === void 0 ? void 0 : _a.statusSynaps) !== UserKycStatusSynaps.APPROVED ? (_jsx(NoKyc, {})) : (_jsxs(Container, { children: [_jsx("p", { children: t('feedback.message') }), _jsx(InputSelect, { label: t('feedback.input.label'), onChange: function (event) { return setCurrentTab(event.target.value); }, options: tabs.map(function (tab) { return ({ label: tab.label, value: tab.value }); }), value: (tab === null || tab === void 0 ? void 0 : tab.value) || '' }), tab && (_jsxs(_Fragment, { children: [_jsx("p", { children: tab.description }), token ? _jsx("div", { "data-token": token, "data-upvoty-portal": tab.boardId || 'boards' }) : _jsx(Loader, { black: true }), _jsx("p", { children: t('feedback.common.abuse') })] }))] }, tab === null || tab === void 0 ? void 0 : tab.boardId))] }) })] }));
}
export default Feedback;
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 24px;\n  padding: 40px;\n  width: 100%;\n\n  & > div > select {\n    margin-bottom: 48px;\n    width: 280px;\n  }\n\n  .note-title {\n    font-weight: 700;\n  }\n\n  @media screen and (max-width: 824px) {\n    gap: 0;\n    padding: 24px 16px;\n  }\n\n  & > p {\n    text-align: center;\n    width: 100%;\n\n    @media screen and (max-width: 824px) {\n      margin: 16px 0;\n    }\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 24px;\n  padding: 40px;\n  width: 100%;\n\n  & > div > select {\n    margin-bottom: 48px;\n    width: 280px;\n  }\n\n  .note-title {\n    font-weight: 700;\n  }\n\n  @media screen and (max-width: 824px) {\n    gap: 0;\n    padding: 24px 16px;\n  }\n\n  & > p {\n    text-align: center;\n    width: 100%;\n\n    @media screen and (max-width: 824px) {\n      margin: 16px 0;\n    }\n  }\n"])));
var templateObject_1;
